export function FullScreenLoader({ label }: { label?: string }) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-md bg-bg">
      <div
        className="h-10 w-10 animate-spin rounded-full border-4 border-border border-t-primary"
        role="status"
        aria-label={label || 'Loading'}
      />
      {label ? <p className="text-body-sm text-text-secondary">{label}</p> : null}
    </div>
  )
}
